import { FC } from "react";
import styles from "./styles.scss";
import resetStyles from "@/scss/reset.scss";
import { filter, map } from "lodash";
import clsx from "clsx";
import { NewsContentPageItem } from "@/services/api";

export const NewsBoardItem: FC<NewsContentPageItem> = ({
  TitleE,
  CMS_Content,
}) => {
  const isPublishedItems = filter(CMS_Content, item => item.IsPublish);

  return (
    <div className={styles.newsBoardItem}>
      <h1 className={styles.itemTitle}>{TitleE}</h1>

      {map(isPublishedItems, (item, index) => (
        <div
          key={`CMS_Content-${index}`}
          className={clsx(styles.itemDescription, resetStyles.defaultUi)}
          dangerouslySetInnerHTML={{ __html: item.ContentTextE }}
        />
      ))}
    </div>
  );
};
